import {getSnapshot, types} from "mobx-state-tree";
import programElements from "../assets/program-elements";
import {persistStore} from "./PersistStore";
import importantElements from "../assets/important-elements";
import interactiveElements from "../assets/interactive-elements";
import config from './../config';
import moodBoardData from "../assets/moodboard-data";
import {circlePackStore} from "./layouts/CirclePackStore";

const Result = types
    .model('Result', {
        idx: types.integer,
        options: types.array(types.integer),
        audience: types.optional(types.array(types.string), []),
    }).views(self => ({
        get total() {
            return self.options.reduce((a, c) => a + c);
        },
        get maximum() {
            return self.options.reduce((max, c) => c > max ? c : max);
        }
    }));

const InteractiveElementResult = types
    .model('InteractiveElementResult', {
        id: types.identifier,
        questions: types.map(Result)
    }).actions(self => ({
        setData(data) {
            if (!data || !data.questions) return;
            Object.keys(data.questions).forEach((k) => {
                if (!self.questions.has(k)) return;
                self.questions.get(k).options = data.questions[k].options;
            });
        }
    }));

const Rankings = types
    .model('Rankings', {
        id: types.identifier,
        total: types.optional(types.integer, 0),
        scores: types.map(types.number)
    });

export const ResultStore = types
    .model('ResultStore', {
        interactiveElements: types.map(InteractiveElementResult),
        rankings: types.map(Rankings),
    })
    .views(self => ({
        getAverageScore(group, id) {
            const rankings = self.rankings.get(group);
            if (!rankings || rankings.total === 0) return 0;
            return rankings.scores.get(id) / rankings.total;
        },
        getScore(group, id) {
            const rankings = self.rankings.get(group);
            if (!rankings) return 0;
            return rankings.scores.get(id);
        },
    }))
    .actions(self => ({
        afterCreate() {
            const hashId = encodeURIComponent("A6S3f@8c0-79*0a-11Bea-b834-c3f34f#c03");
            fetch(config.apiURL + "getResultsData?hashId=" + hashId)
                .then(response => response.json())
                .then(data => {
                    // console.log('results:', JSON.stringify(data));
                    programElements.forEach((group, i) => {
                        group.elements.forEach((programElement, i) => {
                            const rank = data.programRanks[programElement.id];
                            resultStore.addScore('program', {id: programElement.id, score: rank ? rank.score : 0}, rank ? rank.total : 0);
                        });
                    });
                    importantElements.forEach((elem, i) => {
                        const rank = data.importantRanks[elem.id];
                        resultStore.addScore('important', {id: elem.id, score: rank ? rank.score : 0}, rank ? rank.total : 0);
                    });
                    moodBoardData.forEach((image, i) => {
                        resultStore.addScore('moodboard', {id: image.key, score: data.moodBoardSelections[image.key] || 0});
                    });
                    interactiveElements.forEach((elem, i) => {
                        const interactiveElement = self.interactiveElements.get(elem.id);
                        interactiveElement.setData(data.interactiveElements[elem.id]);
                    });
                    persistStore.setMetadata(data.metadata);
                });
        },
        addScore(group, elem, total) {
            let rankings = self.rankings.get(group);
            if (!rankings) {
                rankings = Rankings.create({id: group, scores: {}});
                self.rankings.put(rankings);
            }
            if (total) {
                rankings.total = total;
            }
            rankings.scores.set(elem.id, elem.score);
            return true;
        },
    }));

const emptyResultsByQ = {};
interactiveElements.forEach((elem, i) => {
    let newElem = {id: elem.id, questions: {}};
    elem.questions.forEach((question, i) => {
        if (!question.options) return;
        const newQ = {idx: i, audience: question.audience, options: []};
        for (let j = 0; j < question.options.length; j++) {
            newQ.options.push(0);
        }
        newElem.questions[question.id] = newQ;
    });
    emptyResultsByQ[elem.id] = newElem;
});

export const resultStore = ResultStore.create({
    interactiveElements: emptyResultsByQ
});
